import { tv } from "@fanka/tailwind-variants";

export const CARD_CLASS_NAMES = tv({
  base: "p-4 rounded-[5px] shadow-low min-w-[178px] max-w-[576px]",
  variants: {
    colorType: {
      default: "bg-grayScale-0",
      beige: "bg-brand-beige",
    },
    clickable: {
      true: "cursor-pointer",
    },
  },
  compoundVariants: [
    {
      colorType: "default",
      clickable: true,
      class: "hover:bg-grayScale-100 active:bg-grayScale-200",
    },
    {
      colorType: "beige",
      clickable: true,
      class: "hover:bg-brand-beige-500 active:bg-brand-beige-700",
    },
  ],
  defaultVariants: {
    colorType: "default",
    clickable: false,
  },
});
